var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderId
    ? _c(
        "div",
        { staticClass: "action-dropdown" },
        [
          _c(
            "md-menu",
            { attrs: { "md-size": "medium", "md-align-trigger": "" } },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-button",
                  attrs: { "md-menu-trigger": "", title: "Actions" },
                },
                [_c("md-icon", [_vm._v("more_horiz")])],
                1
              ),
              _c(
                "md-menu-content",
                [
                  _c(
                    "md-menu-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.updateOrder()
                        },
                      },
                    },
                    [
                      _c("md-icon", [_vm._v("edit")]),
                      _c("span", [
                        _vm._v(
                          "\n                    Update Order\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.putOrderOnHold()
                        },
                      },
                    },
                    [
                      _c("md-icon", [
                        _vm._v(
                          _vm._s(
                            _vm.status == "On Hold"
                              ? "play_circle_outline"
                              : "pause"
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "menu-item" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.status == "On Hold"
                                ? "Resume Order"
                                : "Place on Hold"
                            ) +
                            "\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "md-menu-item",
                    {
                      staticClass: "md-danger",
                      on: {
                        click: function ($event) {
                          return _vm.cancelOrder()
                        },
                      },
                    },
                    [
                      _c("md-icon", [_vm._v("close")]),
                      _c("span", { staticClass: "menu-item" }, [
                        _vm._v(
                          "\n                    Cancel Order\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("md-divider"),
                  _c(
                    "md-menu-item",
                    {
                      class: [{ "btn-disabled": !_vm.canDelete }],
                      attrs: { disabled: !_vm.canDelete },
                      on: {
                        click: function ($event) {
                          return _vm.handleDelete()
                        },
                      },
                    },
                    [
                      _c("md-icon", [_vm._v("delete")]),
                      _c("span", { staticClass: "menu-item" }, [
                        _vm._v(
                          "\n                    Delete Order\n                "
                        ),
                      ]),
                      !_vm.canDelete
                        ? _c("md-tooltip", [
                            _vm._v(
                              "You cannot delete a delivered/cancelled order."
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }